import { faChevronCircleDown } from "@fortawesome/free-solid-svg-icons/faChevronCircleDown";
import { faChevronCircleRight } from "@fortawesome/free-solid-svg-icons/faChevronCircleRight";
import { faCircleXmark } from "@fortawesome/free-solid-svg-icons/faCircleXmark";
import { faGear } from "@fortawesome/free-solid-svg-icons/faGear";
import { faSearch } from "@fortawesome/free-solid-svg-icons/faSearch";
import { faTimesCircle } from "@fortawesome/free-solid-svg-icons/faTimesCircle";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PagedMessageResponse } from "app/api/types/PagedMessageResponse";
import { DataFormatoPT } from "app/types/DataFormatoPT";
import clsx from 'clsx';
import { useFormik } from "formik";
import * as R from 'ramda';
import React, { useEffect, useState } from "react";
import globalMU from "../../../globalMU";
import { InputMascara } from "../inputs/InputMascara";
import { Paginacao } from "../itens-orcamento/paginacao/Paginacao";
import { Coluna as ColunaSelecao, SelecionarColunasParaExibicao } from "../selecionar-colunas-para-exibicao/SelecionarColunasParaExibicao";
import { Separador } from "../separador/Separador";
import { InputData } from "../inputs/InputData";
const estiloUltimasCompras = require("./ultimas-compras.module.scss").default;
const estiloFormulario = require('../../estilos/formulario.module.scss').default
const estiloRelatorioVertical = require('../../estilos/relatorioVertical.module.scss').default
// const estiloSeparador = require('../../estilos/separador.module.scss').default
const estiloTabela = require('../../estilos/tabelas.module.scss').default
import { fonteGradeOuHerdada } from 'app/utils/tamanhoFonteGrid'

export type PesquisaUltimasCompras = {
  ClasseProduto: string;
  CodigoCliente: number;
  CodigoFornecedor: string;
  CodigoProduto: string;
  CodigosProdutos: string[];
  DataFinal: DataFormatoPT;
  DataInicial: DataFormatoPT;
  DescricaoProduto: string;
  NumeroPagina: number;
  ReferenciaProduto: string;
  TamanhoPagina: number;
}



export type UltimasComprasItem = {
  DataVenda?: string;
  ReferenciaProduto?: string;
  CodigoProduto?: string;
  DescricaoProduto?: string;
  Lote?: string;
  LoteReserva?: string;
  LoteSaida?: string;
  NomeBitola?: string;
  NomeBitolaReserva?: string;
  NomeBitolaSaida?: string;
  NomeTonaliadeReserva?: string;
  NomeTonaliadeSaida?: string;
  NomeTonalidade?: string;
  NomeVendedor?: string;
  NumeroPedido?: number;
  Preco?: number;
  Quantidade?: number;
  QuantidadeItemReservaLote?: number
  QuantidadeItemSaidaLote?: number
  ValidadeLote?: string
  ControleValidadeLote?: number
  LoteVencido?: boolean;
  QtdeItemSaidaLote?: number;
  QuantidadeLote?: number;
  QuantidadeReservaLote?: number
  QuantidadeSaidaLote?: number
  NomeSistemaTintometrico?: string
  ModeloProduto?: string
  NomeCor?: string
  NomeFormaDePagar?: string
}



export type Produto = {
  Codigo: string
  Descricao: string;
};

export type UltimasComprasPesquisa = {};

export type ColunaUltimasCompras = {
  Nome?: string
  Permitido?: boolean
  Selecionada?: boolean
  Codigo?: number
  Ordem?: number
}

export type UltimasComprasProps = {
  onPesquisaClasse: () => void;
  onPesquisaFornecedor: () => void;
  onLimparFornecedor: (fornecedor: string) => void;
  onPesquisar: (pesquisaUltimasCompras: PesquisaUltimasCompras,numeroPagina: number) => void;
  onPesquisarProdutos: () => void;
  onExcluirProdutoLista: (codigo: string) => void;
  onAlterarListaSelecionada: (numeroIndexPagina: number) => void;
  onAlterarFonte: (tamanho: number) => void;
  onToggleColunaSelecionada: (nome: string, selecionada: boolean) => void
  onToggleSelecionarTodasColunas: (selecionar: boolean) => void
  onNumeroPaginaModificado: (numeroPagina: number) => void
  processando?: boolean
  tamanhoFonte: number;
  cpfcnpj: string;
  nome: string;
  mascara: string;
  pesquisaUltimasCompras: PesquisaUltimasCompras;
  produtosSelecionados: Produto[];
  corSelecionado?: string;
  textoSelecionado?: string;
  loteVencido: boolean;
  ultimasCompras: PagedMessageResponse<UltimasComprasItem>;
  descricaoProduto: string;
  colunas: ColunaUltimasCompras[]
  exibirCodigoOuReferencia: "CODIGO" | "REFERENCIA"
  classe?: string
  nomeFornecedor?: string
  mostrarMaisFiltros?: boolean
  numeroCasasDecimaisQuantidade: number
  numeroCasasDecimaisPreco: number
  exibirLupaPesquisaDeProdutos: boolean
};



export const UltimasCompras = (props: UltimasComprasProps) => {
  const [mostrarMaisFiltros, setMostrarMaisFiltros] = useState(props.mostrarMaisFiltros ?? false)
  const [mostrarProdutosFiltrados, setMostrarProdutosFiltrados] = useState(false)
  const [ultimaCompraSelecionado, setUltimaCompraSelecionado] = useState<UltimasComprasItem[]>()
  const [exibirSelecaoDeColunas, setExibirSelecaoDeColunas] = useState(false)

  const formik = useFormik({
    initialValues: {
      ...props.pesquisaUltimasCompras,
      ClasseProduto: props.classe ?? "",
      DescricaoProduto: props.descricaoProduto,
      CodigosProdutos: props.produtosSelecionados?.map((value) => value.Codigo),
    },
    onSubmit: (values, { }) => { },
    enableReinitialize: true,
  });

  const toggleultimaCompraSelecionado = (ultimaCompra) => {
    if (ultimaCompraSelecionado == ultimaCompra) {
      setUltimaCompraSelecionado(null);
    } else {
      setUltimaCompraSelecionado(ultimaCompra);
    }
  };

  const dadosCliente = <div className={clsx(estiloRelatorioVertical.container, "_w-2/5 _ml-32")}>
    <span className={estiloRelatorioVertical.cabecalho} >CPF/CNPJ</span>
    <span className={estiloRelatorioVertical.dado}>{props.cpfcnpj}</span>

    <span className={estiloRelatorioVertical.cabecalho}>Nome</span>
    <span className={estiloRelatorioVertical.dado}>{props.nome}</span>
  </div>

  const maisFiltrosToggle = <>

    <div className={clsx(estiloUltimasCompras.toggle)}
      id="UltimasCompras_MaisFiltrosToggle_div"
      onClick={() => setMostrarMaisFiltros(!mostrarMaisFiltros)}>
      <div className={clsx("_text-right")}>
        <FontAwesomeIcon
          id="UltimasCompras_MaisFiltrosToggle_icone"
          className="_text-lg"
          icon={mostrarMaisFiltros ? faChevronCircleDown : faChevronCircleRight}
        />
      </div>

      <span
        id="UltimasCompras_MaisFiltrosToggle"
        style={{ cursor: "pointer", userSelect: "none" }}
      >
        Mais Filtros
      </span>


    </div>


  </>

  const formularioPesquisa1 = () => {

    const dataInicial = <>
      <label>Data Inicial</label>
      <InputData
        id="UltimasCompras_DataInicial"
        disabled={props.processando}
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataInicial)}
        onChange={e => { formik.setFieldValue("DataInicial", e) }}
        selecionaValorOnFocus
      />
    </>

    const dataFinal = <>
      <label>Data Final</label> 
       <InputData
        disabled={props.processando}
        id="UltimasCompras_DataFinal"
        data={globalMU.converterDataHoraFormatoENComTParaDataFormatoPT(formik.values.DataFinal)}
        onChange={e => { formik.setFieldValue("DataFinal", e) }}
        selecionaValorOnFocus
      />
    </>

    const lupaPesquisarProdutos = <>
      <label style={{ paddingTop: "10px" }}>Produtos</label>
      <FontAwesomeIcon
        id="UltimasCompras_LupaPesquisarProdutos"
        onClick={() => props.onPesquisarProdutos()}
        cursor="pointer"
        style={{ paddingTop: "10px" }}
        className={"material-icons"}
        color="#3c8ac9"
        icon={faSearch}
      />
    </>

    return <div className={clsx(estiloFormulario.formulario, "_ml-32")}>

      {dataInicial}

      {dataFinal}

      {props.exibirLupaPesquisaDeProdutos && lupaPesquisarProdutos}


    </div>
  }

  const formularioPesquisa2 = () => {

    const codigo = <>
      <label>Código</label>
      <input
        // style={{ width: "100px" }}
        name="CodigoProduto"
        id="UltimasCompras_CodigoProduto"
        maxLength={5}
        disabled={props.processando}
        value={formik.values?.CodigoProduto ?? ''}
        onChange={formik.handleChange}
      />
    </>

    const referencia = <>
      <label>Referência</label>
      <input
        name="ReferenciaProduto"
        id="UltimasCompras_ReferenciaProduto"
        disabled={props.processando}
        maxLength={30}
        value={formik.values?.ReferenciaProduto ?? ''}
        onChange={formik.handleChange}
      />
    </>

    const descricao = <>
      <label>Descrição</label>
      <input
        name="DescricaoProduto"
        id="DescricaoProduto"
        disabled={props.processando}
        maxLength={100}
        value={formik.values?.DescricaoProduto ?? ''}
        onChange={formik.handleChange}
      />
    </>

    const classe = <>
      <label>Classe</label>
      <div>
        <InputMascara
          id="UltimasCompras_ClasseProduto"
          mascara="99.999.999"
          disabled={props.processando}
          valor={formik.values.ClasseProduto ?? ""}
          emitirComMascara={true}
          onValorModificado={valor => formik.setFieldValue("ClasseProduto", valor)}
        />

        <FontAwesomeIcon
          id="UltimasCompras_LupaClasse"
          cursor="pointer"
          style={{ padding: "0 6px 0 6px" }}
          color="#3c8ac9"
          icon={faSearch}
          fontSize={"20px"}
          onClick={() => props.onPesquisaClasse()}
        />
        <FontAwesomeIcon
          id="UltimasCompras_LimparClasse"
          cursor="pointer"
          color="#f25713"
          fontSize={"20px"}
          icon={faTimesCircle}
          onClick={() =>
            formik.setFieldValue("ClasseProduto", "")
          }
        />

      </div>
    </>

    const fornecedor = <>
      <label>Fornecedor</label>
      <div>
        <input
          id="UltimasCompras_Fornecedor"
          value={props.nomeFornecedor ?? ''}
          disabled={true}
          readOnly={true}
        />
        <FontAwesomeIcon
          id="UltimasCompras_LupaFornecedor"
          cursor="pointer"
          style={{ padding: "0 6px 0 6px" }}
          color="#3c8ac9"
          fontSize={"20px"}
          icon={faSearch}
          onClick={() => props.onPesquisaFornecedor()}
        />
        <FontAwesomeIcon
          id="UltimasCompras_LimparFornecedor"
          cursor="pointer"
          color="#f25713"
          fontSize={"20px"}
          icon={faTimesCircle}
          onClick={() =>
            props.onLimparFornecedor(formik.values.CodigoFornecedor)
          }
        />
      </div>
    </>

    return <div className={clsx(estiloFormulario.formulario, "_ml-32")}>
      {codigo}
      {referencia}
      {descricao}
      {classe}
      {fornecedor}
    </div>
  }

  const produtosFiltradosToggle = <>
    <div className={clsx(estiloUltimasCompras.toggle)}
      id="UltimasCompras_ProdutosFiltradosToggle"
      onClick={() => setMostrarProdutosFiltrados(!mostrarProdutosFiltrados)}>
      <FontAwesomeIcon
        id="UltimasCompras_IconeProdutosFiltradosToggle"
        className="_text-lg"
        icon={mostrarProdutosFiltrados ? faChevronCircleDown : faChevronCircleRight}
      />

      <span>
        Produtos filtrados
      </span>

    </div>
  </>

  const tabelaProdutosFiltrados = <>
    <table className={clsx(estiloTabela.tabela, "_w-full")}
      id="UltimasCompras_TabelaProdutosFiltrados"
    >
      <thead></thead>
      <tbody id="UltimasCompras_CorpoTabela">
        {props.produtosSelecionados?.map((produto) => (
          <tr key={produto.Codigo}
            id={`UltimasCompras_Produto_${produto.Codigo}`}
          >
          <td
            id={`UltimasCompras_Produto_Codigo_${produto.Codigo}`}
          >
            {produto.Codigo}
          </td>
          <td
            id={`UltimasCompras_Produto_Descricao_${produto.Codigo}`}
          >
            {produto.Descricao}
          </td>
          <td
            id={`UltimasCompras_Produto_Icone_${produto.Codigo}`}
          >
            <FontAwesomeIcon
              id={`UltimasCompras_Produto_IconeFont_${produto.Codigo}`}
              onClick={() => props.onExcluirProdutoLista(produto.Codigo)}
              cursor={"pointer"}
              style={{ padding: "3px" }}
              className={"material-icons"}
              color="#f25713"
              icon={faCircleXmark}
            />
          </td>
          

        </tr>))}
      </tbody>
    </table>
  </>

  const pesquisar = <button
    className={estiloUltimasCompras.buttonPesquisarUltimasCompras}
    id="UltimasCompras_BotaoPesquisar"
    disabled={props.processando}
    onClick={() => {
      props.onPesquisar(
        {
        ...formik.values,
        DataInicial: globalMU.converterDataFormatoENParaPT(formik.values.DataInicial),
        DataFinal: globalMU.converterDataFormatoENParaPT(formik.values.DataFinal)
      }, 1 );
    }}>
    Pesquisar
  </button>

  const traduzirNomeColuna = (nomeColuna: string) => {
    const nomeParaCabecalhoMap = {
      "DataVenda": "Data",
      "NumeroOrcamento": "Orçamento",
      "QuantidadeLote": "Quantidade Lote",
      "ValidadeLote": "Validade Lote",
      "CodigoProduto": props.exibirCodigoOuReferencia == "CODIGO" ? "Código" : "Referência",
      "QuantidadeItem": "Quantidade",
      "SistemaTintometrico": "Sistema Tintométrico",
      "ModeloProduto": "Modelo",
      "NomeCor": "Cor",
      "FormaPagamento": "Forma de Pagamento"
    }

    return nomeColuna in nomeParaCabecalhoMap ? nomeParaCabecalhoMap[nomeColuna] : nomeColuna
  }

  const cabecalhoColunaTabelaUltimasCompras = ({ nomeColuna }: {
    nomeColuna: string
  }) => {

    return (props.colunas ?? []).find(c => c.Nome == nomeColuna)?.Selecionada ?? false 
    ? <th
      id={`UltimasCompras_Cabecalho_${nomeColuna.replace(/\s+/g, '')}`}
    >
      {traduzirNomeColuna(nomeColuna)}
    </th> : <></>
  }

  const ordenarColunas = (colunas: ColunaUltimasCompras[]) => R.sort((c1, c2) => c1.Ordem - c2.Ordem, colunas)

  const itemTabelaUltimasCompras = ({
    nomeColuna,
    ultimasComprasItem
  }: {
    nomeColuna: string
    ultimasComprasItem: UltimasComprasItem
  }) => {

    const fn = R.cond([
      [R.equals("DataVenda"), _ => <span>
        {globalMU.converterDataFormatoENParaPT(ultimasComprasItem.DataVenda)}
      </span>],

      [R.equals("NumeroOrcamento"), _ => <span>
        {ultimasComprasItem.NumeroPedido}
      </span>],

      [R.equals("Vendedor"), _ => <span>
        {ultimasComprasItem.NomeVendedor}
      </span>],

      [R.equals("Lote"), _ => <span>
        {ultimasComprasItem.Lote}
      </span>],

      [R.equals("Tonalidade"), _ => <span>
        {ultimasComprasItem.NomeTonalidade}
      </span>],

      [R.equals("Bitola"), _ => <span>
        {ultimasComprasItem.NomeBitola}
      </span>],

      [R.equals("QuantidadeLote"), _ => <div className={estiloTabela.dadoNumerico}>
        {globalMU.formatarValorNumerico(ultimasComprasItem.QuantidadeLote, props.numeroCasasDecimaisQuantidade, false)}
      </div>],

      [R.equals("ValidadeLote"), _ => <span>
        {ultimasComprasItem.ValidadeLote}
      </span>],

      [R.equals("QuantidadeItem"), _ => <div className={estiloTabela.dadoNumerico}>
        {globalMU.formatarValorNumerico(ultimasComprasItem.Quantidade, props.numeroCasasDecimaisQuantidade, false)}
      </div>],

      [R.equals("CodigoProduto"), _ => <span>
        {props.exibirCodigoOuReferencia == "CODIGO" ? ultimasComprasItem.CodigoProduto : ultimasComprasItem.ReferenciaProduto}
      </span>],

      [R.equals("Produto"), _ => <span>
        {ultimasComprasItem.DescricaoProduto}
      </span>],

      [R.equals("Preço"), _ => <div className={estiloTabela.dadoNumerico}>
        {globalMU.formatarValorNumerico(ultimasComprasItem.Preco, props.numeroCasasDecimaisPreco, true)}
      </div>],

      [R.equals("SistemaTintometrico"), _ => <span>
        {ultimasComprasItem.NomeSistemaTintometrico}
      </span>],

      [R.equals("ModeloProduto"), _ => <span>
        {ultimasComprasItem.ModeloProduto}
      </span>],

      [R.equals("NomeCor"), _ => <span>
        {ultimasComprasItem.NomeCor}
      </span>],

      [R.equals("FormaPagamento"), _ => <span>
        {ultimasComprasItem.NomeFormaDePagar}
      </span>],

      [R.T, _ => <span>

      </span>]
    ])

    return fn(nomeColuna)
  }

  const botoesTabelaUlimasCompras = <div className={estiloTabela.acoesHead}>

    <FontAwesomeIcon icon={faGear} className="_text-2xl _cursor-pointer"
      id="UltimasCompras_BotaoConfigurarColunas"
      onClick={() => setExibirSelecaoDeColunas(true)} />

    <button
      className={clsx('no-global-button', estiloTabela.botaoAumentarDiminuirFonte)}
      onClick={() => props.onAlterarFonte?.(props.tamanhoFonte + 1)}
      disabled={props.tamanhoFonte >= 26}
    >A+
    </button>
    <button
      className={clsx('no-global-button', estiloTabela.botaoAumentarDiminuirFonte)}
      onClick={() => props.onAlterarFonte?.(props.tamanhoFonte - 1)}
      disabled={props.tamanhoFonte <= 8}
    >A-
    </button>
  </div>

  const tabelaUltimasCompras = <>

    {botoesTabelaUlimasCompras}

    <div className={estiloTabela.containerRolavel}>
      <table className={clsx(estiloTabela.tabela, "_w-full")}>
        <thead>
          <tr>
            {ordenarColunas(props.colunas ?? []).filter(c => c.Selecionada).map(coluna => {
              const cabecalho = cabecalhoColunaTabelaUltimasCompras({ nomeColuna: coluna.Nome })
              return React.isValidElement(cabecalho)
                ? React.cloneElement(cabecalho as React.ReactElement<any>, { key: coluna.Nome })
                : null
            })}
            <th
              id="UltimasCompras_Produto_UltimaColuna_Vazia_Cabecalho"
            />
          </tr>

        </thead>
        <tbody style={{ fontSize: fonteGradeOuHerdada(props.tamanhoFonte) }}>
          {((props.ultimasCompras?.Entities ?? []).map((ultimasComprasItem) =>
          <tr key={`${ultimasComprasItem.NumeroPedido}-${ultimasComprasItem.CodigoProduto}-${ultimasComprasItem.Lote ?? ''}`}>
            {ordenarColunas(props.colunas ?? [])
                  .filter(c => c.Selecionada)
                  .map((coluna, indexColuna) => 
                  
                  <td 
                    key={`${indexColuna}${coluna.Nome.replace(/\s+/g, '')}`}
                    id={`UltimasCompras_${coluna.Nome.replace(/\s+/g, '')}-${ultimasComprasItem.CodigoProduto.replace(/\s+/g, '')}`}
                    >
              {itemTabelaUltimasCompras({
                nomeColuna: coluna.Nome,
                ultimasComprasItem
              })}
            </td>)}
            <td
              id="UltimasCompras_Produto_UltimaColuna_Vazia"
            />
          </tr>))}
        </tbody>
      </table>
    </div>

  </>


  const selecaoDeColunasDialog = <SelecionarColunasParaExibicao
    colunas={(props.colunas ?? []).map((coluna, index) => ({
      nome: coluna.Nome,
      selecionada: coluna.Selecionada,
      colunaOriginal: coluna,
    }) as ColunaSelecao)}
    mostrar={exibirSelecaoDeColunas}
    funcaoOrdenacao={(c1, c2) => (c1.colunaOriginal as ColunaUltimasCompras).Ordem - (c2.colunaOriginal as ColunaUltimasCompras).Ordem}
    funcaoTraducaoNome={coluna => traduzirNomeColuna((coluna.colunaOriginal as ColunaUltimasCompras).Nome)}
    onClose={() => setExibirSelecaoDeColunas(false)}
    onToggleColunaSelecionada={(coluna, selecionada) => props.onToggleColunaSelecionada(coluna.nome, selecionada)}
    onToggleSelecionarTodasColunas={props.onToggleSelecionarTodasColunas}
  />

  useEffect(() => {
    setMostrarMaisFiltros(props.mostrarMaisFiltros)
  }, [props.mostrarMaisFiltros])


  return <>
    {dadosCliente}

    <Separador />

    {formularioPesquisa1()}

    {maisFiltrosToggle}

    {mostrarMaisFiltros && <>

      <Separador />

      {formularioPesquisa2()}
    </>}

    {(props.produtosSelecionados ?? []).length > 0 && <>
      {produtosFiltradosToggle}

      {mostrarProdutosFiltrados && <>
        <Separador />

        {tabelaProdutosFiltrados}
      </>}
    </>}


    {pesquisar}

    {tabelaUltimasCompras}

    {((props.ultimasCompras?.PageCount ?? 0) > 1) &&
      <Paginacao
        paginaAtual={props.ultimasCompras.ActualPage}
        totalPaginas={props.ultimasCompras.PageCount}
        id="UltimasCompras_Paginacao"
        onAlterarListaSelecionada={props.onNumeroPaginaModificado} />}

    {selecaoDeColunasDialog}

    {<section style={{ marginBottom: "100px" }} />}
  </>
};
